export default __webpack_public_path__ + "static/media/createNftImg.1e6d1cf8.png";